import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: { },
    permissions: [],
    notifications: [],
    collapsed: false,
    productId: '',
    company: null
  },
  plugins: [createPersistedState()],
  getters: {
    getLoggedUser: (state) => {
      return state.user
    },

    getLoggedUserId: (state) => {
      return state.user.id
    },

    getNotifications: (state) => {
      return state.notifications
    },

    getPermissions: (state) => {
      return state.permissions
    },

    getProductId: (state) => {
      return state.productId
    },

    getCompany: (state) => {
      return state.company
    },

    getCollapseState: (state) => {
      return state.collapsed
    }

  },
  mutations: {
    setLoggedUser: (state, payload) => {
      state.user = payload
    },

    removeLoggedUser: (state, payload) => {
      state.user = {}
      state.permissions = []
      state.notifications = []
      state.productId = ''
      state.company = null
    },

    setPermissions: (state, payload) => {
      state.permissions = payload
    },

    setProductId: (state, payload) => {
      state.productId = payload
    },

    setCompany: (state, payload) => {
      state.company = payload
    }
  },

  actions: {
    setLoggedUser: ({ commit }, payload) => {
      commit('setLoggedUser', payload)
    },
    removeLoggedUser: ({ commit }, payload) => {
      commit('removeLoggedUser', payload)
    },
    setPermissions: ({ commit }, payload) => {
      commit('setPermissions', payload)
    },
    setProductId: ({ commit }, payload) => {
      commit('setProductId', payload)
    },
    setCompany: ({ commit }, payload) => {
      commit('setCompany', payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js